const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.backgroundProvider.';

const BACKGROUND_TITLE = `${DOMAIN}title`;

export { BACKGROUND_TITLE };
